import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

import { Line } from './styles'

const AttendanceHeader = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader style={{ padding: 0 }} ghost={false} title={t('components.pages.attendance.pageHeader.title')} />
      <Line />
    </>
  )
}

AttendanceHeader.displayName = 'AttendanceHeader'
export default AttendanceHeader
